var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D7C0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20711 12L9.47837 9.72874L9.47855 9.72855C9.57232 9.63479 9.625 9.50761 9.625 9.375C9.625 9.36699 9.62481 9.35898 9.62442 9.35098C9.61845 9.22682 9.56645 9.10934 9.47855 9.02145C9.38479 8.92768 9.25761 8.875 9.125 8.875C8.99239 8.875 8.86521 8.92768 8.77145 9.02145L8.77126 9.02163L6.14645 11.6464C6.05268 11.7402 6 11.8674 6 12C6 12.1326 6.05268 12.2598 6.14645 12.3536L8.77139 14.9785C8.86521 15.0723 8.99239 15.125 9.125 15.125C9.25761 15.125 9.38479 15.0723 9.47855 14.9786C9.57232 14.8848 9.625 14.7576 9.625 14.625C9.625 14.4924 9.57232 14.3652 9.47855 14.2714L7.20711 12Z",
    fill: "#6000E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.5H6.5C6.22386 11.5 6 11.7239 6 12C6 12.2761 6.22386 12.5 6.5 12.5L13.5 12.5C13.7761 12.5 14 12.2761 14 12C14 11.7239 13.7761 11.5 13.5 11.5Z",
    fill: "#6000E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H13.5C13.2239 17 13 17.2239 13 17.5C13 17.7761 13.2239 18 13.5 18H17C17.4142 18 17.7071 17.7071 17.7071 17.7071C18 17.4142 18 17 18 17V7C18 6.58578 17.7071 6.29289 17.7071 6.29289C17.4142 6 17 6 17 6H13.5C13.2239 6 13 6.22386 13 6.5C13 6.77614 13.2239 7 13.5 7H17V17Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fea9b558d827e948d5ae6f3ad658e147.svg";
export { ForwardRef as ReactComponent };